import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const {
        attendanceXRayNature,
        attendanceXRayNatureGroup,
        attendanceXRayAttendants,
        attendanceXRayTeam,
        attendanceXRayStreet,
        attendanceXRaySector,
        attendanceXRayChannel
    } = useReportFiltersFetch({
        fetchAttendanceXRayNature: true,
        fetchAttendanceXRayNatureGroup: true,
        fetchAttendanceXRayAttendants: true,
        fetchAttendanceXRayTeam: true,
        fetchAttendanceXRayStreet: true,
        fetchAttendanceXRaySector: true,
        fetchAttendanceXRayChannel: true
    });

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Atendimento'
                        isMulti={false}
                        options={[
                            {label: "Todos", value: 'all'},
                            {label: "Com despacho", value: 'with_dispatch'},
                            {label: "Sem despacho", value: 'without_dispatch'}
                        ]}
                        value={filters.dispatch}
                        onChange={(value) => setFilters(prev => ({...prev, dispatch: value}))}
                        instanceId="dispatch"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                    <SelectComponent
                        label='Natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={attendanceXRayNature}
                        value={filters.nature}
                        onChange={(value) => setFilters(prev => ({...prev, nature: value}))}
                        instanceId="nature"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Grupo de natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={attendanceXRayNatureGroup}
                        value={filters.nature_group}
                        onChange={(value) => setFilters(prev => ({...prev, nature_group: value}))}
                        instanceId="nature_group"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Atendentes'
                        isMulti={true}
                        wrapValues={true}
                        options={attendanceXRayAttendants}
                        value={filters.attendants}
                        onChange={(value) => setFilters(prev => ({...prev, attendants: value}))}
                        instanceId="attendants"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Equipe'
                        isMulti={true}
                        wrapValues={true}
                        options={attendanceXRayTeam}
                        value={filters.team}
                        onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                        instanceId="team"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Logradouro'
                        isMulti={true}
                        wrapValues={true}
                        options={attendanceXRayStreet}
                        value={filters.street}
                        onChange={(value) => setFilters(prev => ({...prev, street: value}))}
                        instanceId="street"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Setor'
                        isMulti={true}
                        wrapValues={true}
                        options={attendanceXRaySector}
                        value={filters.sector}
                        onChange={(value) => setFilters(prev => ({...prev, sector: value}))}
                        instanceId="sector"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Canal'
                        isMulti={true}
                        wrapValues={true}
                        options={attendanceXRayChannel}
                        value={filters.channel}
                        onChange={(value) => setFilters(prev => ({...prev, channel: value}))}
                        instanceId="channel"
                        classNameWrapper={"w-full"}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;